/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Fade } from 'react-reveal';
import Slider from 'react-slick';
import { Button, Container } from 'reactstrap';
import ProjectCard from '../components/ProjectCard';
import { projects } from '../portfolio';

const settings = {
  dots: true,
  infinite: true,
  speed: 100,
  slidesToShow: 2,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};

function Projects() {
  return (
    <section className="section section-lg">
      <Container>
        <Fade bottom duration={1000} distance="40px">
          <div className="d-flex p-4">
            <div>
              <div className="icon icon-lg icon-shape bg-gradient-white shadow rounded-circle text-info">
                <i className="ni ni-laptop text-info" />
              </div>
            </div>
            <div className="pl-4 d-flex ">
              <h4 className="display-3 text-info">Projects</h4>
            </div>
          </div>

          {/* <Row className="row-grid align-items-center"> */}
          {/* <div className="d-flex flex-wrap justify-content-center">
              {projects.map((project) => (
                <ProjectCard key={project.id} project={project} />
              ))}
            </div> */}
          <Slider {...settings}>
            {projects.map((project) => (
              <ProjectCard key={project.id} project={project} />
            ))}
          </Slider>
          <Button
            target="_"
            href="https://github.com/yeasin-hossain"
            className="bg-info text-white"
          >
            View All Projects
          </Button>
          {/* </Row> */}
        </Fade>
      </Container>
    </section>
  );
}

export default Projects;
